import { useEffect } from "react";
import { useRecoilState } from 'recoil';
import _ from "lodash";
import cn from "classnames";

import { CSS_COMPONENT_PREFIX } from 'config';
import useSessionTracker from 'hooks/useSessionTracker';
import { favouriteTickets, selectedFavouriteTicket } from "state";
import { withConfigContext } from "hooks/useConfig";
import { useAuth, withCustomerData } from "../../hooks/useAuth";
import "styles/pages/favourites.scss";

import FavouritesLoading from "components/favourites/FavouritesLoading";
import FavouritesLogin from "./FavouritesLogin/FavouritesLogin";
import FavouritesEmpty from "components/favourites/FavouritesEmpty";
import FavouritesForm from "components/favourites/FavouritesForm";

const Favourites = ({
  onGetValues,
  apiAccessToken,
  apiUrl,
  brand,
  disableBackground,
  env,
  favouritesData
}) => {
  const {favouritesLoading} = favouritesData;

  const [tickets] = useRecoilState(favouriteTickets);
  const [selectedTicket, setSelectedTicket] = useRecoilState(selectedFavouriteTicket);

  useSessionTracker();

  const { customer } = useAuth({ apiAccessToken, apiUrl, brand, env });

  useEffect(() => {
    if (!selectedTicket && tickets?.length) {
      setSelectedTicket(tickets[0]);
    }
  }, [tickets, selectedTicket]); // eslint-disable-line react-hooks/exhaustive-deps

  const baseClass = CSS_COMPONENT_PREFIX + 'widget__content';
  const classes = cn(baseClass, {
    [`${baseClass}--bg-hidden`] : disableBackground
  });

  return (
    <div className={classes}>
      <div className="otrl-jp__favourites" data-test-id='jp__tab--favourites'>
        {favouritesLoading ? <FavouritesLoading /> :
          !customer ? <FavouritesLogin /> :
            !selectedTicket ? <FavouritesEmpty /> :
              <FavouritesForm onGetValues={onGetValues} />
        }
      </div>
    </div>
  );
};

export default _.flow(withCustomerData, withConfigContext)(Favourites);
